import { AddressItem } from 'components/common/address-item/AddressItem';

export const testId = 'addressListtestId';

type AddressListProps = {
  addresses?: object;
  hasTitle?: boolean;
};

export const AddressList = ({ addresses = {}, hasTitle = true }: AddressListProps) => {
  return (
    <div data-testid={testId}>
      {Object.entries(addresses).map(([fuel, addressObj]) => (
        <AddressItem
          key={fuel}
          fuel={fuel}
          address={addressObj}
          hasTitle={hasTitle}
        />
      ))}
    </div>
  );
};
